<template>
  <div class="clock-loading">
    <div ref="lottieIcon" class="lottie-icon"></div>
    <div class="text">{{
      type == 1 ? '您的计划正在生成中…' : '正在启动该计划…'
    }}</div>
  </div>
</template>
<script>
import lottie from 'lottie-web'
export default {
  props: {
    type: {
      type: Number,
      default: 1 // 1表示创建 2表示启动
    }
  },
  data() {
    return {}
  },
  mounted() {
    this.lottie = lottie.loadAnimation({
      container: this.$refs.lottieIcon, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'https://gymvue.gymcity.com.cn/json/clock-create.json' // the path to the animation json
    })
  },
  methods: {}
}
</script>
<style scoped lang="scss">
.clock-loading {
  height: 100vh;
  background-color: rgba(249, 249, 249, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .text {
    margin-top: 10px;
    font-size: 15px;
    font-family: PingFangSC, PingFang SC;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
    padding-bottom: 30px;
  }
}

.lottie-icon {
  width: 129px;
  height: 100px;
}
</style>
